// iqChat.js
import { IQ_API_BASE_URL } from "../config/apiConfig";

// export async function iqChat(endpoint, options = {}) {
//   const token = localStorage.getItem("access_token");

//   const finalOptions = {
//     method: options.method || "GET",
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       ...(options.headers || {}),
//     },
//     body: options.body || undefined,
//     signal: options.signal, // support AbortController
//   };

//   try {
//     const response = await fetch(`${IQ_API_BASE_URL}${endpoint}`, finalOptions);

//     // Response interceptor logic
//     if (!response.ok) {
//       switch (response.status) {
//         case 401:
//           console.error("Unauthorized access - perhaps redirect to login");
//           break;
//         case 403:
//           console.error("Forbidden access");
//           break;
//         case 404:
//           console.error("Resource not found");
//           break;
//         case 500:
//           console.error("Internal server error");
//           break;
//         default:
//           console.error(`Error: ${response.status}`);
//       }
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }

//     return response; // leave as raw response to allow streaming
//   } catch (error) {
//     if (error.name === "AbortError") {
//       console.warn("Request aborted");
//     } else {
//       console.error("Fetch error:", error);
//     }
//     throw error;
//   }
// }

export async function iqChat(endpoint, options = {}) {
  const token = localStorage.getItem("access_token");

  const isFormData = options.body instanceof FormData;

  const finalOptions = {
    method: options.method || "GET",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(isFormData
        ? {}
        : { "Content-Type": "application/x-www-form-urlencoded" }),
      ...(options.headers || {}),
    },
    body: options.body || undefined,
    signal: options.signal, // support AbortController
  };

  try {
    const response = await fetch(`${IQ_API_BASE_URL}${endpoint}`, finalOptions);

    if (!response.ok) {
      switch (response.status) {
        case 401:
          console.error("Unauthorized access - perhaps redirect to login");
          break;
        case 403:
          console.error("Forbidden access");
          break;
        case 404:
          console.error("Resource not found");
          break;
        case 500:
          console.error("Internal server error");
          break;
        default:
          console.error(`Error: ${response.status}`);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
  } catch (error) {
    if (error.name === "AbortError") {
      console.warn("Request aborted");
    } else {
      console.error("Fetch error:", error);
    }
    throw error;
  }
}
